export enum AccountingBasis {
  Accrual = 'accrual',
  Cash = 'cash',
}
